import axios from "@/api/axiosInstance";
import { OpportunitiesResponse } from "../types";

export const fetchOpportunitiesBySalesperson = async (
  email: string,
  signal?: AbortSignal,
): Promise<OpportunitiesResponse> => {
  const response = await axios.get<OpportunitiesResponse>(
    `/api/private/sales-portal/opportunities/salesperson/${encodeURIComponent(email)}`,
    { signal },
  );
  return response.data;
};
